module.exports = __webpack_public_path__ + "img/logo3.79a558c3.png";